/**
 * Author:hong.rong
 * Desc:无效数据展示页
 * Date:2022-06-02
 */

import * as React from 'react'
import styles from './index.module.less'

type ErrorPageType = {
  message: string
}

export default function ErrorPage({ message }: ErrorPageType) {
  return (
    <div className={styles.errorPage}>
      <div className={styles.icon}>
        <img draggable="false" src="/images/draft.svg" alt="" />
      </div>
      <div className={styles.message}>{message}</div>
    </div>
  )
}
